// src/components/Overlay.js

import React, { useState, useEffect } from 'react';
import { navigate } from 'hookrouter';
import {
  useSceneStore,

} from '../store'
import GridItem from '../components/GridItem';
import CloseButton from '../components/CloseButton';
import BSCawards from '../components/BSCawards';
import Carousel from '../components/Carousel';



const BscOverlay = () => {
 
  const { isCategoryOverlayVisible } = useSceneStore(state => state)
  const { setIsCategoryOverlayVisible, setCursorActive, setTopic } = useSceneStore(state => state.actions)
  const [showIntroPanel, setShowIntroPanel] = useState(false)


  useEffect(() => {
    setIsCategoryOverlayVisible(true);
  }, []);



  const setCursor = (msg, boo) => {
    setCursorActive(boo)
    setTopic(msg)
  }

  const toggleOverlay = () => {

    setIsCategoryOverlayVisible(false);
  };



  return (
    <div className={`overlay bsc-overlay bsc-overlay-2026 ${isCategoryOverlayVisible ? 'active' : ''}`}>
       <CloseButton
            toggleOverlay={toggleOverlay}
        />
         <div className="overlay-content">
         <img
           className="bsc26-title-image"
           src="/assets/images/BSC2026-title.png"
           alt="Book Song Challenge 2026"
           width="6367"
           height="1061"
         />
            
          <div className="bsc26-content-container">

            <p className="bsc26-intro-text">
            The Book Song Challenge celebrates books and music by asking kids of all ages to write and perform an original song/rap about their favorite book from the school year for the chance to win big prizes for themselves and the library of their choice.
            </p>
            <p className="bsc26-intro-text">
            <b>The winners of the 7th Annual Book Song Challenge have been awarded!</b> Check out the videos below to see our Grand Prize winners and "Way Past Wow" special awards announcements. You can also view all winners and entries on our Instagram page <a href="https://www.instagram.com/waypastbooks/" target="_blank">@WayPastBooks</a> 
            </p>
            {/*
            <p className="bsc26-intro-text">
            Questions? Email us via <a href="mailto:connect@waypastbooks.com" target="_blank">connect@waypastbooks.com</a>.
            </p>
            */}
         


  


           

        
        </div>

        
          
          <hr className="bsc26-divider"/>

          
          <BSCawards />

          <div className='overlay-headline'>
            <h2 style={{
              marginBottom: '10px'
            }}>More Book Song Challenge Fun</h2>
            <p style={{
              textAlign: 'center',
              marginTop: '0px',
              marginBottom: '40px'
            }}>Check out these highlights from past Book Song Challenges</p>
          </div>
          <div className="grid-content">

          

          <GridItem 
                  title="Book Song Challenge 2026 Flyer"
                  image="/assets/images/BookSongChallenge2026_Flyer_Vertical.jpg"
                  url="http://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2026/04/BookSongChallenge2026_Flyer.pdf"
                  target="_blank"
                />

<GridItem 
                  title="Book Song Challenge 2025 Winners"
                  image="/assets/images/BSC25_WinnersVideo_Website.png"
                  url="https://www.instagram.com/p/DJch5xkxBYM/"
                  target="_blank"
                  orient="horiz"
                  //type="video"
                />


                <GridItem 
                  title="Book Song Challenge 2025 Flyer"
                  image="/assets/images/BookSongChallenge2025_Flyer_600.jpg"
                  url="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2025/04/BookSongChallenge2025_Flyer.pdf"
                  target="_blank"
                />

<GridItem 
                  title="Book Song Challenge 2024 Winners"
                  image="/assets/images/bsc2024_winners.png"
                  url="https://www.instagram.com/p/C6zJbOmv91q/"
                 target="_blank"
                //  orient="horiz"
                //  type="video"
                />

                <GridItem 
                  title="Book Song Challenge 2024 Flyer"
                  image="/assets/images/BSC24_AnnouncementFlyer-poster.jpg"
                  url="/assets/images/pdf/BookSong2024-announcement.pdf"
                  target="_blank"
                />

                <GridItem 
                  title="Book Song Challenge 2023 Winners"
                  image="/assets/images/BSC23_Winners-Thumbnail.jpg"
                  url="https://youtu.be/YIb6T3A2E64"
                  // target="_blank"
                  orient="horiz"
                  type="video"
                />
                <GridItem 
                  title="Book Song Challenge 2023 Flyer"
                  image="/assets/images/BSC23_AnnouncementFlyer-poster.jpg"
                  url="/assets/images/pdf/BSC23_AnnouncementFlyer.pdf"
                  target="_blank"
                />
                <GridItem 
                  title="Book Song Challenge 2022 Winners"
                  image="/assets/images/bsc22-winners-poster.jpg"
                  url="https://youtu.be/cKQ35QO-udE"
                  // target="_blank"
                  orient="horiz"
                  type="video"
                />



              <GridItem 
                  title="Book Song Challenge 2022 Flyer"
                  image="/assets/images/BSC22_AnnouncementFlyer02-poster.jpg"
                  url="/assets/images/pdf/BSC22_AnnouncementFlyer02.pdf"
                  target="_blank"
                />
                <GridItem 
                  title="Book Song Challenge 2021 Highlights"
                  image="/assets/images/bsc2021-highlights-poster.jpg"
                  url="https://youtu.be/g-2EbmdzxLE"
                 // target="_blank"
                  orient="horiz"
                  type="video"
                />
                <GridItem 
                  title="Book Song Challenge 2021 Flyer"
                  image="/assets/images/BSC21_Flyer_v2_with_Abigail_white-poster.jpg"
                  url="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2023/12/BSC21_Flyer_v2-with-Abigail.pdf"
                  target="_blank"
                />



              <GridItem 
                  title="Book Song Challenge 2020 Flyer"
                  image="/assets/images/BSC20_Flyer-poster.jpg"
                  url="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2023/12/BSC-2020-Flyer.pdf"
                  target="_blank"
                />
            
          </div>
        </div>
      </div>

  );
};

export default BscOverlay;